module.exports = __webpack_public_path__ + "static/spec-effects-03343f5dcf05cf1e57603cbd52f66e58.png";